import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface SenatRegistration {
  id: string;
  first_name: string;
  last_name: string;
  birth_date: string;
  birth_place: string;
  email: string | null;
  phone: string | null;
  amount: number;
  payment_status: string;
  created_at: string;
}

export const useSenatData = () => {
  const [registrations, setRegistrations] = useState<SenatRegistration[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchRegistrations = async () => {
      try {
        setIsLoading(true);
        const { data, error: fetchError } = await supabase
          .from("senat_dinner_registrations")
          .select(
            "id, first_name, last_name, birth_date, birth_place, email, phone, amount, payment_status, created_at"
          )
          .order("created_at", { ascending: false });

        if (fetchError) throw fetchError;
        setRegistrations((data as SenatRegistration[]) || []);
      } catch (err) {
        console.error("Error fetching senat dinner registrations:", err);
        setError(err instanceof Error ? err : new Error("Unknown error"));
      } finally {
        setIsLoading(false);
      }
    };

    fetchRegistrations();
  }, []);

  return { registrations, isLoading, error };
};
